(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("cl-react-graph", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["cl-react-graph"] = factory(require("react"), require("react-dom"));
	else
		root["cl-react-graph"] = factory(root["React"], root["ReactDOM"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_51__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition